import t from 'react-translate';
import AiGenerationPreview from '../../ai-config-modal/ai-scenario-generating-preview';

const AiFeedback = () => {
  const aiGenerationTexts = [
    t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.REVIEWING_CONVERSATION(),
    t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.COMPARING_LEARNER_GOALS(),
    t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.PREPARING_FEEDBACK(),
  ];
  return (
    <div className='w-100'>
      <AiGenerationPreview
        aiGenerationTexts={aiGenerationTexts}
      />
    </div>
  );
};

export default AiFeedback;
